
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({})
export default class DatePicker extends Vue {
	@Prop({ default: null, required: false }) private model;
	@Prop({ default: null, required: true }) private label;
	@Prop({ default: null, required: false }) private errors;
	@Prop({ default: null, required: false }) private valid;
	@Prop({ default: false, required: false }) private initialize;
	@Prop({ default: false, required: false }) private initialWithMin;
	@Prop({ default: false, required: false }) private disabled;
	@Prop({ default: false, required: false }) private clearable;
	@Prop({ default: '', required: false }) private min;
	@Prop({ default: '', required: false }) private max;
	// N-288 · 5A: un texto gris bajo el campo («Movida con la llegada: …»).
	@Prop({ default: '', required: false }) private hint;

	@Watch('model')
	model_change(value) {
		this.date = value;
	}

	private date: string;
	private formatted_date: string;
	private locale: string;
	private menuDate: boolean;

	constructor() {
		super();
		this.date = '';
		this.formatted_date = '';
		this.locale = '';
		this.menuDate = false;
	}

	mounted() {
		this.locale = this.$i18n.locale;
		if (this.model) {
			this.date = this.model;
		} else if (this.initialize) {
			this.date = new Date().toISOString().substr(0, 10);
		}
	}

	setDate() {
		// N-288 (8-oct): la mínima solo se propone con el campo VACÍO. Antes, abrir el
		// calendario pisaba en pantalla la fecha que había (tras mover la salida con la
		// llegada, se veía un día menos) sin cambiar lo que se guarda.
		if (this.min && this.initialWithMin && !this.date) {
			this.date = this.min;
		}

	}

	get formattedDate() {
		// N-285: una fecha que se queda vacía se VE vacía. Antes el campo seguía enseñando
		// la anterior: al retrasar la llegada, la salida se borraba por dentro y en pantalla
		// parecía intacta (llegada 28/06, salida 25/06).
		if (!this.date) {
			return '';
		}
		const [year, month, day] = this.date.split('-');
		if (this.locale === 'es') {
			this.formatted_date = `${day}/${month}/${year}`;
		} else {
			this.formatted_date = `${year}/${month}/${day}`;
		}
		return this.formatted_date;
	}

	set formattedDate(value: any) {
		this.formatted_date = value;
	}
}
